import type { RouteLocationNormalized } from 'vue-router'
import { DEFAULT_APP_PLATFORM } from '@/const/platformAccess'
import { PUBLIC_PAGE_NAMES } from '@/const/routes'

/** Same names as public auth/legal/referral routes — no tuition/platform gate there. */
export const SKIP_PLATFORM_ACCESS_ROUTE_NAMES = new Set<string>([
  ...PUBLIC_PAGE_NAMES
])

export function shouldSkipPlatformAccessCheck(to: RouteLocationNormalized): boolean {
  const name = to.name as string | undefined
  if (name && SKIP_PLATFORM_ACCESS_ROUTE_NAMES.has(name)) {
    return true
  }
  if (to.path.startsWith('/tuition')) {
    return true
  }
  if (to.path.startsWith('/referral-action')) {
    return true
  }
  return false
}

/** Deepest matched `meta.requiresPlatform`, or the default app platform code. */
export function getRequiredPlatformForRoute(to: RouteLocationNormalized): string {
  for (const record of [...to.matched].reverse()) {
    const p = record.meta.requiresPlatform
    if (typeof p === 'string' && p.length > 0) {
      return p
    }
  }
  return DEFAULT_APP_PLATFORM
}
